<!-- 8mbets -->
<template>
    <div class="h-full">
        <div v-if="!isMobile" class="sports-bg bg-center bg-cover h-full" :class="`${dashboardStore.data?.currency} `" :style="`background-image: url(${backgroundImage})`">
            <MerchantMarqueeAnnounce/>
            <div class="container sport">
                <div class="py-7 flex items-center justify-end relative min-h-[1000px]">
                    <img v-if="footBallStarImage" class="sport_character_img" :src="$pub(footBallStarImage)" alt="sport_stars" />
                    <div v-if="gamesStore.sport.ready && providerStore.ready" class="flex flex-wrap w-[800px] relative">
                        <div v-if="mainStore.loadingGame" class="loading_bg !z-20">
                            <Spinner/>
                        </div>
                        <button @click="playGame(i[0])" v-for="(i, index) in gameList" :aria-label="index" :key="index" type="button" class="sport_btn placeholder" :class="dashboardStore.maintenanceData[i[0].provider_id] ? 'maintenance' : ''">
                            <div class="sport_btn_aspect_ratio"></div>
                            <img :src="getSportImage(index)" :alt="`sport_${index}`">
                            <div class="sport_btn_bg"></div>
                            <div class="text-white text-sm absolute bottom-3 left-5 z-10 uppercase">{{ index }}</div>
                            <div v-if="dashboardStore.maintenanceData[i[0].provider_id]" class="maintenance_box !rounded-none">
                                <div class="maintenance_text">
                                    <div class="maintenance_text_1">
                                        <span v-if="dashboardStore.maintenanceData[i[0].provider_id].end_date != '-'">{{ $t('maintenance_note', {start_date: dashboardStore.maintenanceData[i[0].provider_id].start_date, end_date: dashboardStore.maintenanceData[i[0].provider_id].end_date})}}</span>
                                        <span v-else>{{ $t('maintenance_note_2', {start_date: dashboardStore.maintenanceData[i[0].provider_id].start_date})}}</span>
                                    </div>
                                    <div class="maintenance_text_2">[{{i[0].provider_name}}]</div>
                                </div>
                            </div>
                        </button>
                    </div>
                    <div v-else class="flex flex-wrap w-[800px] relative">
                        <button v-for="i in 8" :key="i" type="button" class="sport_btn" :aria-label="$t('sport')">
                            <div class="skeleton sport_btn_aspect_ratio"></div>
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <template v-if="isMobile">
            <div  class="overflow-y-auto" :class="'h-[calc(100vh-var(--offset))] supports-[height:100dvh]:h-[calc(100dvh-var(--offset))]'" :style="`--offset: calc(100px + ${redeemBannerHeight}px)`">
                <MerchantHomeGameContainerMobile category="sport" :hideMenu="true"/>
            </div>
        </template>
    </div>
</template>

<script setup>
const { isMobile } = useDevice();
const config = useRuntimeConfig();
const mainStore = useMainStore();
const gamesStore = useGamesStore();
const userStore = useUserStore();
const dashboardStore = useDashboardStore();
const { $pub, $resolveUrl } = useNuxtApp();
const providerStore = useProviderStore();

const readyWatcher = watchEffect(() => {
    if (providerStore.ready && (!userStore.loggedIn || (userStore.loggedIn && dashboardStore.ready))) {
        gamesStore.getGames('sport')
        readyWatcher()
    }
}, {
    flush: 'post'
})

watch(() => userStore.loggedIn, () => {
    gamesStore.getGames('sport')
})

const getSportImage = (p) => {
    if (p) {
        return $resolveUrl(`{d}game/games/sport/page/${p.toUpperCase()}.webp`);
	} else {
		return $pub('/img/logo.png');
	}
}

const playGame = (e) => {
    var game = {
        provider_name: e.provider_name,
        currency: dashboardStore.data.currency,
        provider_id: e.provider_id,
        game_id: e.game_id,
        maintenance: dashboardStore.maintenanceData[e.provider_id]
    }
    gamesStore.playGame(game);
}


const gameList = computed(() => {
    if (!providerStore.ready || !gamesStore["sport"].ready) {
        return {}
    }
    if (gamesStore["sport"].list) {
        if (!gamesStore["sport"].list) {
            return {}
        }
        
        let allGames = gamesStore["sport"].list;
        delete allGames.ALL;
        return allGames;
    }
    return {}
})


const redeemBannerHeight = ref(0);
let getRedeemBanner = null;

const initBannerCheck = () => {
    if (getRedeemBanner) { // already added event, skip
        return
    }
    getRedeemBanner = document.querySelector(".redeemBanner");
    if (!getRedeemBanner) { // element not found, skip
        return
    }
    window.addEventListener('resize', resizeHandlerRedeemBanner);
    resizeHandlerRedeemBanner();
}

const resizeHandlerRedeemBanner = () => {
    if (getRedeemBanner) {
        redeemBannerHeight.value = getRedeemBanner.clientHeight;
    } else {
        redeemBannerHeight.value = 0;
    }
}

onMounted(() => {
    if (mainStore.showRedeemBanner) {
        setTimeout(() => {
            initBannerCheck()
        }, 300)
    }
})


watch(() => mainStore.showRedeemBanner, (isTrue) => {
    if (isTrue) {
        nextTick(() => {
			setTimeout(() => {
				initBannerCheck()
			}, 300)
        })
    }
    else {
        window.removeEventListener('resize', resizeHandlerRedeemBanner);
        resizeHandlerRedeemBanner();
    }
})

onBeforeUnmount(() => {
    window.removeEventListener('resize', resizeHandlerRedeemBanner);
})

const footBallStarImage = computed(() => '')

const backgroundImage = computed(() =>  $pub('/img/bg_sport.webp'))

</script>

<style scoped>
.sport_btn {
    overflow: hidden;
    position: relative;
    margin: 10px;
    width: calc(50% - 20px);
}

.sport_btn .sport_btn_aspect_ratio {
    width: 100%;
    padding-top: calc(100% / 1.666666);
}

.sport_btn img {
    width: 100%;
    position: absolute;
    transition: all 0.3s;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%) scale(1);
}
.isDesktop .sport_btn:hover img {
    transform: translate(-50%, -50%) scale(1.2);
}
.sport_btn_bg {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    opacity: 0;
    transition: all 0.3s;
}
.isDesktop .sport_btn:hover .sport_btn_bg {
    opacity: 1;
}

.sport_btn.sport_btn.maintenance {
    cursor: default!important;
}

.isDesktop .sport_btn.maintenance:hover img {
    transform: scale(1);
}
.isDesktop .sport_btn.maintenance:hover .sport_btn_bg {
    opacity: 0;
}
</style>